/**
 * @voltxampere/ui — 2N2222 NPN BJT variant (Sprint 38-1)
 *
 * Reference: onsemi NSC4 datasheet 2N2222A (TO-92, switching/amp).
 *   Is = 14.3e-15 A
 *   Bf = 200            (Bf min 100 @ I_C = 150 mA)
 *   Vaf = 75 V
 *
 * Higher Is + lower Bf vs 2N3904 — better for medium-power switching.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { npn } from "../npn.js";
export const bjtNpn2n2222 = {
    id: "2n2222",
    nameTr: "2N2222 (NPN, TO92)",
    nameEn: "2N2222 (NPN, TO92)",
    shortcut: "Q",
    category: "active",
    viewBox: npn.viewBox,
    terminals: npn.terminals,
    defaultLabel: "Q",
    defaultValue: "2N2222",
    schemaType: "bjt-npn",
    defaultParams: { Is: 14.3e-15, Bf: 200, Vaf: 75 },
    renderSVG: () => npn.renderSVG(),
};
//# sourceMappingURL=bjt-npn-2n2222.js.map